import type { ChannelData } from '../../types'

interface ChannelStrengthProps {
  channels: Record<string, ChannelData>
}

const CHANNEL_ORDER = ['website', 'social', 'paid', 'pr', 'gmb']

export default function ChannelStrength({ channels }: ChannelStrengthProps) {
  return (
    <div className="space-y-3">
      <h3 className="text-sm font-semibold text-gray-900">Channel Strength Breakdown</h3>
      <div className="border rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-gray-50 border-b">
              <th className="text-left px-4 py-2 font-semibold text-gray-600">Channel</th>
              <th className="text-center px-4 py-2 font-semibold text-gray-600">Weight</th>
              <th className="text-center px-4 py-2 font-semibold text-gray-600">Score</th>
              <th className="text-center px-4 py-2 font-semibold text-gray-600">Available</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {CHANNEL_ORDER.map((key) => {
              const ch = channels[key]
              if (!ch) return null

              return (
                <tr key={key} className="hover:bg-gray-50">
                  <td className="px-4 py-2.5 font-medium text-gray-900">{ch.label}</td>
                  <td className="text-center px-4 py-2.5 text-gray-600">
                    {(ch.weight * 100).toFixed(0)}%
                  </td>
                  <td className="text-center px-4 py-2.5 font-semibold text-gray-900">
                    {typeof ch.score === 'number' ? ch.score.toFixed(1) : '—'}
                  </td>
                  <td className="text-center px-4 py-2.5 text-gray-600">
                    {ch.available_submetrics}/{ch.total_submetrics}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}
